export enum InputTypeEnum {
  text = 'text',
  number = 'number',
  textarea = 'textarea',
  percent = 'percent',
  time = 'time',
}

export type InputType = `${InputTypeEnum}`;
